/** String form of a primitive; objects/arrays give '' instead of '[object Object]'. */
export function asText(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? String(value) : '';
  }
  if (typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value);
  }
  return '';
}
